import { Select, styled } from '@mui/material';
import { coreThemeColors } from '@youscience/theme';
import { CoreBox, CoreTypography } from '@youscience/core';

export const StyledContentSchoolListHeaderFilterGroup = styled(CoreBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  flex: 'none',
  gap: '0.75rem',
  [theme.breakpoints.down('md')]: {
    flex: 'auto',
    flexDirection: 'column',
    gap: '0.25rem',
  },
}));

export const StyledContentSchoolListHeaderFilter = styled(CoreBox)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '0.5rem',
}));

export const StyledContentSchoolListHeaderFilterText = styled(CoreTypography)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  [theme.breakpoints.down('md')]: {
    flex: '1',
  },
}));

export const StyledContentSchoolListHeaderFilterSelect = styled(Select)(({ theme }) => ({
  color: coreThemeColors.secondary.main,

  '.MuiOutlinedInput-input': {
    fontSize: '0.875rem',
    padding: '0.5rem 1rem',
    marginRight: '0.35rem',
  },

  '.MuiOutlinedInput-notchedOutline': {
    borderRadius: '40px',
    border: `1px solid ${coreThemeColors.secondary.main}`,
    borderColor: `${coreThemeColors.secondary.main} !important`,
  },

  '& > svg:first-of-type': {
    color: coreThemeColors.secondary.main,
  },

  '&:hover': {
    '.MuiOutlinedInput-notchedOutline': {
      border: `1px solid ${coreThemeColors.secondary.dark}`,
    },
  },

  [theme.breakpoints.down('md')]: {
    flex: '3',
  },
}));

export const StyledContentSchoolListHeaderDivider = styled(CoreBox)(() => ({
  flex: 'none',
  width: '1px',
  border: `1px solid ${coreThemeColors.grey[300]}`,
}));
